module.exports = __webpack_public_path__ + "img/[弱].4d8393fe.svg";